import React from 'react';
import InlineReference from './InlineReference';

import { getResourceFromEntityData } from '../../../utilities/schemaUtility';

const ResourceInlineReference = (props) => {
    const { entityKey, contentState } = props;
    const entityData = contentState.getEntity(entityKey).getData();
    const resource = getResourceFromEntityData(entityData);

    return (
        <InlineReference
            url={resource.getUrl()}
            cssSelector={resource.getCustomClass()}
            isInternalReference={resource.isInternal()}
            {...props}
        />
    );
};

export default ResourceInlineReference;
